import { Block } from '@xprog/prensa'
// import { enviarClickItem } from 'hooks/useGCJAnalytics'
import map from 'lodash/map'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import * as S from './TopbarItems.styled'
import { TopbarItemsProps, TopbarItemProps } from './TopbarItems.types'

const TopbarItem: React.FC<TopbarItemProps> = (props) => {
  let li_css = { ...props.css?.li }

  const handleSendClickEvent = (itemName: string, local: string) => {
    //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickItem(itemName, local);
  }

  if (props.color && props.selected === props.pathSegment) {
    li_css = {
      ...li_css,
      '> a': {
        borderBottomColor: `$${props.color}`,
        '&:hover': { borderBottomColor: `$${props.color}` }
      }
    }
  } else {
    li_css = {
      ...li_css,
      'a:hover': {
        borderBottomColor: `$${props.color}`,
      }
    }
  }
  return (
    <Block as='li' css={li_css} onClick={() => handleSendClickEvent(props.name, 'minicapa')}>
      <a href={props.path}>
        <S.TopbarItemLabel
          path={props.path}
          variant='menuTag-desktop'
          css={props.css?.label}
        >
          {props.name}
        </S.TopbarItemLabel>
      </a>
    </Block>
  )
}

const TopbarItems = (props: TopbarItemsProps) => {
  const router = useRouter()
  const slug = router.asPath.split('/')
  const pageDataSlug = slug[1]
  return (
    <S.TopbarItemContainer
      css={props.css?.container}
      hideInMobile={props.hideInMobile}
    >
      {map(props.items, (item: TopbarItemProps, key) => (
        <TopbarItem
          key={key}
          css={props.css?.item}
          selected={pageDataSlug}
          {...item}
        />
      ))}
    </S.TopbarItemContainer>
  )
}

export default TopbarItems
